import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'id',
    fullName: 'Indonesian',
    nativeName: 'Indonesia',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Sesuatu yang Luar Biasa Akan Datang",
    landing_subtitle: "ArgVoid adalah studio pengembangan aplikasi dan game. Pantau terus, hal-hal baru akan segera hadir!",
    select_language: "Pilih Bahasa",
    search_placeholder: "Telusuri bahasa...",
    terms_title: "Ketentuan Layanan",
    policy_title: "Kebijakan Privasi",
    cookies_title: "Kebijakan Cookie",
    terms_content: `
        <strong>1. Penerimaan Ketentuan</strong><br>
        Dengan mengakses ArgVoid, Ketentuan Layanan ini diterima. Jika persyaratan ini tidak disetujui, layanan tidak boleh digunakan.<br><br>

        <strong>2. Penggunaan Platform</strong><br>
        ArgVoid dan aplikasinya disediakan "sebagaimana adanya" untuk tujuan informasi dan kreatif. Layanan ini harus digunakan hanya untuk tujuan yang sah.<br><br>

        <strong>3. Perilaku yang Dilarang</strong><br>
        Dilarang keras mengeksploitasi kerentanan situs, mengirim spam, atau mencoba akses tidak sah ke infrastruktur.<br><br>

        <strong>4. Penafian</strong><br>
        Platform dan layanan dapat diubah kapan saja tanpa pemberitahuan. Tidak ada jaminan yang diberikan mengenai waktu aktif atau ketersediaan layanan.
    `,
    policy_content: `
        <strong>1. Pengumpulan Informasi</strong><br>
        Platform tidak memerlukan otentikasi pengguna atau pembuatan akun saat ini. Tidak ada informasi identitas pribadi (seperti nama atau alamat email) yang dikumpulkan secara aktif dari pengunjung.<br><br>

        <strong>2. Penggunaan Data</strong><br>
        Analisis dasar yang dianonimkan dapat dikumpulkan untuk memahami lalu lintas situs dan meningkatkan aplikasi. Data ini tidak ditautkan ke identitas pengguna individu.<br><br>

        <strong>3. Layanan Pihak Ketiga</strong><br>
        Penyedia pihak ketiga dapat digunakan untuk layanan hosting dan analitik. Praktik privasi masing-masing penyedia ini mengatur data anonim yang diproses di infrastruktur mereka.<br><br>

        <strong>4. Keamanan Data</strong><br>
        Langkah-langkah keamanan yang wajar diterapkan untuk melindungi platform. Namun, tidak ada metode transmisi melalui Internet yang sepenuhnya aman.<br><br>
    `,
    cookies_content: `
        <strong>1. Apa itu Cookie dan Penyimpanan Lokal? </strong><br>
        Cookie dan penyimpanan lokal browser adalah file data kecil yang disimpan di perangkat untuk mengingat preferensi konfigurasi di seluruh kunjungan.<br><br>

        <strong>2. Tujuan Penggunaan</strong><br>
        Penyimpanan Lokal Browser digunakan secara ketat untuk menyimpan pengaturan konfigurasi, seperti: <br>
        - Preferensi bahasa<br>
        - Konfigurasi antarmuka pengguna (mis., pengaturan tata letak atau tema)<br>
        - Cache aplikasi sementara<br><br>

        <strong>3. Tidak Ada Pelacakan</strong><br>
        Cookie dan penyimpanan lokal tidak digunakan untuk tujuan periklanan atau pelacakan pihak ketiga. Semua data yang disimpan hanya untuk fungsi inti platform.<br><br>

        <strong>4. Kontrol</strong><br>
        Data browser dapat dihapus kapan saja melalui pengaturan browser, yang akan mengatur ulang semua konfigurasi lokal.
    `,
    cookie_consent_text: "Kami menggunakan cookie dasar untuk memastikan situs web berfungsi dengan benar, seperti menjaga sesi Anda tetap aktif, menyimpan preferensi bahasa Anda, dan konfigurasi khusus lainnya.",
    read_policy: "Baca Kebijakan Cookie",
    support_title: "Hubungi Dukungan",
    support_subject_label: "Subjek",
    support_message_label: "Pesan",
    support_submit_button: "Kirim Pesan",
    support_hint: "Catatan: Ini akan membuka aplikasi email default Anda untuk mengirim pesan.",
    support_success_msg: "Membuka aplikasi email Anda...",
    support_error_msg: "Gagal mengirim pesan. Silakan coba lagi nanti.",
    explorer_title: "Penjelajah",
    history_title: "Sejarah",
    animation_title: "Animasi",
    config_title: "Konfigurasi",
    tool_mouse: "Pilih (Ctrl+M)",
    tool_brush: "Kuas (Ctrl+B)",
    tool_brush_mode: "Mode Beralih (Padat/Jelas)",
    tool_eraser: "Penghapus (Ctrl+E)",
    tool_brush_size: "Sesuaikan Ukuran Kuas",
    tool_bucket: "Isi (Ctrl+F)",
    tool_eyedropper: "Penitis mata",
    tool_grid: "Kisi (Ctrl+Shift+B)",
    tool_rotate: "Putar (Ctrl+Shift+R)",
    tool_flip_h: "Balik H (Ctrl+Shift+H)",
    tool_flip_v: "Balik V (Ctrl+Shift+V)",
    tool_transpose: "Ubah posisi (Ctrl+Shift+T)",
    label_width: "Lebar",
    label_height: "Tinggi",
    label_frames: "Jumlah Bingkai",
    label_animation: "Gaya Animasi",
    label_background_color: "Warna Latar Belakang",
    label_interval: "Selang",
    tool_anim_config: "Konfigurasi Animasi",
    label_new_width: "Lebar Baru",
    label_new_height: "Ketinggian Baru",
    label_apply: "Menerapkan",
    label_colors: "Warna",
    label_size: "Ukuran",
    label_tolerance: "Toleransi",
    val_horizontal: "Horisontal",
    val_vertical: "Vertikal",
    val_sequence: "Urutan",
    val_bounce: "Melambung",
    val_random: "Acak",
    val_solid: "Padat",
    val_clear: "Jernih",
    action_add_sheet: "Lembar Baru",
    action_import: "Impor",
    action_export: "Ekspor",
    action_sort_projects: "Menyortir",
    sort_date_old: "Tertua Pertama",
    sort_date_new: "Terbaru Pertama",
    sort_name_az: "Nama (A-Z)",
    sort_name_za: "Nama (Z-A)",
    action_new_sprite: "Sprite Baru",
    action_new_project: "Proyek Baru",
    modal_save_all_title: "Simpan Semua Perubahan",
    modal_save_all_desc: "Pilih aset yang akan disimpan:",
    modal_save_selected: "Simpan yang Dipilih",
    action_saved: "Disimpan",
    modal_create_sprite_title: "Buat Sprite Baru",
    modal_create_project_title: "Buat Proyek Baru",
    modal_add_sheet_title: "Tambahkan Lembar Baru",
    modal_rename_sheet_title: "Ganti Nama Lembar",
    modal_rename_sprite_title: "Ganti nama Sprite",
    modal_delete_sprite_title: "Hapus Sprite",
    modal_delete_project_title: "Hapus Proyek",
    modal_delete_sheet_title: "Hapus Lembar",
    placeholder_sprite_name: "Nama",
    placeholder_project_name: "Nama",
    placeholder_sheet_name: "Nama",
    placeholder_new_name: "Nama Baru",
    action_create: "Membuat",
    action_add: "Menambahkan",
    action_rename: "Ganti nama",
    action_duplicate: "Duplikat",
    action_delete: "Menghapus",
    action_cancel: "Membatalkan",
    confirm_delete_sprite: "Apakah Anda yakin ingin menghapus sprite ini?",
    confirm_delete_project: "Apakah Anda yakin ingin menghapus proyek ini? Semua sprite akan dihapus.",
    confirm_delete_sheet: "Apakah Anda yakin ingin menghapus sheet ini?",
    err_select_sprite: "Silakan pilih sprite terlebih dahulu.",
    err_select_project: "Silakan pilih proyek terlebih dahulu.",
    err_name_empty: "Nama tidak boleh kosong.",
    err_sprite_exists: "Sprite dengan nama itu sudah ada.",
    err_project_exists: "Proyek dengan nama tersebut sudah ada.",
    err_no_content: "Tidak ada konten untuk disimpan.",
    err_no_changes: "Tidak ada perubahan untuk disimpan.",
    err_delete_last_sheet: "Tidak dapat menghapus lembar terakhir.",
    err_extract_frames: "Tidak dapat mengekstrak bingkai apa pun.",
    err_indexeddb: "Gagal menyimpan secara lokal. Browser Anda mungkin tidak mendukung IndexedDB.",
    msg_upload_success: "Pengunggahan Berhasil: {0}",
    msg_upload_failed: "Gagal Mengunggah: {0}",
    msg_save_success: "Simpan berhasil.",
    msg_saving: "Penghematan...",
    msg_multi_save_result: "{0} aset disimpan. {1} kegagalan.",
    menu_title: "Menu",
    menu_save: "Menyimpan",
    menu_save_all: "Simpan Semua",
    menu_support: "Hubungi Dukungan",
    label_local_storage: "Penyimpanan Lokal",
    label_sign_in: "Masuk",
    modal_export_title: "Ekspor Sprite",
    label_filename: "Nama file",
    label_format: "Format",
    action_export_confirm: "Ekspor",
};

export default translations;
